import { useState, useEffect } from 'react';
import { checkUserCredits, deductCredits, getCreditHistory } from '../services/credits';
import { useAuth } from './useAuth';

export function useCredits() {
  const [credits, setCredits] = useState(0);
  const [loading, setLoading] = useState(true);
  const [history, setHistory] = useState([]);
  const { isAuthenticated } = useAuth();

  const refreshCredits = async () => {
    if (!isAuthenticated) return;
    
    try {
      const result = await checkUserCredits();
      if (result.success) {
        setCredits(result.credits);
      }
    } catch (error) {
      console.error('Errore nel refresh crediti:', error);
    } finally {
      setLoading(false);
    }
  };

  const useCredits = async (amount, description, modelId) => {
    try {
      const result = await deductCredits(amount, description, modelId);
      if (result.success) {
        setCredits(result.remainingCredits);
        return { success: true, remainingCredits: result.remainingCredits };
      }
      return { success: false, error: result.error };
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  const loadHistory = async () => {
    try {
      const result = await getCreditHistory();
      if (result.success) {
        setHistory(result.transactions);
      }
    } catch (error) {
      console.error('Errore nel caricamento storico:', error);
    }
  };

  useEffect(() => {
    refreshCredits();
  }, [isAuthenticated]);

  return {
    credits,
    loading,
    history,
    refreshCredits,
    useCredits,
    loadHistory
  };
}